module.exports = __webpack_public_path__ + "static/media/img.logo.1d11bec5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/LoginThird/UI.Panel/img.logo.svg
// module id = 6928
// module chunks = 0